import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    clientName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    TelNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    Email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    EventExtra1: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    PlannedGuestCount: {
      validations: [
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.'},
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    EventExtra6: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    EventExtra3: {
      validations: []
    },
    EventExtra7: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    EventExtra5: {
      validations: []
    },
    category: {
      validations: []
    },
    Reference: {
      validations: []
    },
    Notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'We look forward to the opportunity to host your group! Please fill out the following form with all the required fields and one of the members of our team will get back to you in 1-3 business days. A confirmation page will follow if the form has been filled out successfully.:',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'FirstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company/Organization:*',
            mapping: 'clientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:*',
            mapping: 'TelNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'Email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker-nofill',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'EventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Is Date Flexible?:*',
            options: [
              { label: 'Yes, date is flexible', value: 'Yes, date is flexible' },
              { label: 'No, date is not flexible', value: 'No, date is not flexible' },
            ],
            mapping: 'EventExtra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Guest Count:*',
            mapping: 'PlannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'What Team Building Package are you interested in?:*',
            options: [
              { label: 'Adventure Package', value: 'Adventure Package' },
              { label: 'Wellness Package', value: 'Wellness Package' },
              { label: 'Sustainability Package', value: 'Sustainability Package' },
            ],
            mapping: 'EventExtra6'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'For an additional cost, which of the following add-ons are you interested to include?:',
            options: [
              { label: 'Facilitated Guided Quarry Hike', value: 'Facilitated Guided Quarry Hike' },
              { label: 'Roasting Fire & Seasonal Treat', value: 'Roasting Fire & Seasonal Treat' },
              { label: 'Lite Snacks & Beverages', value: 'Lite Snacks & Beverages' },
              { label: 'Historical Tour of Evergreen Brick Works', value: 'Historical Tour of Evergreen Brick Works' },
              { label: 'None of the above', value: 'None of the above' },
            ],
            mapping: 'EventExtra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How long are you looking for your event to be?:*',
            options: [
              { label: '1.5 -2 Hours: 2 Activities', value: '1.5 -2 Hours: 2 Activities' },
              { label: '2.5 - 3 Hours: 3 Activities', value: '2.5 - 3 Hours: 3 Activities' },
            ],
            mapping: 'EventExtra7'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Are you interested in booking indoor spaces and/or meeting rooms at Evergreen Brick Works?:',
            options: [
              { label: 'Yes', value: 'Yes' },
              { label: 'No', value: 'No' },
            ],
            mapping: 'EventExtra5'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Are you interested in catering services?:',
            options: [
              { label: 'Yes, I’m interested in catering services', value: 'Yes, I’m interested in catering services' },
              { label: 'No, I’m not interested in catering services ', value: 'o	No, I’m not interested in catering services' },
            ],
            mapping: 'category'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How Did You Hear About Us?:',
            options: [
              { label: 'Search Engine', value: 'Search Engine' },
              { label: 'Instagram', value: 'Instagram' },
              { label: 'Referral', value: 'Referral' },
              { label: 'LinkedIn', value: 'LinkedIn' },
              { label: 'Blog', value: 'Blog' },
              { label: 'Website', value: 'Website' },
            ],
            mapping: 'Reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'XLarge',
            label: 'Additional Information:',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Evergreen Brick Works Program Form',
    formId: '2040',
    clientKey: 'E0B50905-F310-4A5E-9786-EC8A7A796DE2',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://evergreen.ca/evergreen-brick-works/corporate-team-building-inquiry-confirmation/',
    submissionText: 'Your form has been submitted successfully! One of the members of our team will get back to you within 1-3 business days.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
